module.exports = __webpack_public_path__ + "img/sparkles-white.2e1c21aa.svg";